/* eslint import/no-webpack-loader-syntax: off */
import EditorCSS from "!!raw-loader!../../scss/editor.css";

const tinyMCEConfig = {
    height: 400,
    menubar: false,
    skin: false,
    content_css: false,
    plugins: ["link", "table paste", "lists"],
    block_formats:
        "Paragraph=p; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6;",
    font_css:
        "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700;900&display=swap",
    content_style: [
        "body { font-family:'Nunito Sans',Arial,sans-serif; }",
        EditorCSS,
    ].join("\n"),
    toolbar: "formatselect | bold italic underline | bullist numlist | link",
};

export default tinyMCEConfig;
